import { OmitField } from 'src/app/@shared/decorators/api-field.decorator';
import { ModelBase } from '../abstract/model-base.model';
import { NotificationType } from './notification-type.model';

export class ClientUserNotificationSetting extends ModelBase {

    static override CLASS_NAME: string = 'ClientUserNotificationSetting';

    private _notificationType!: NotificationType;
    private _pushEnabled!: boolean;
    private _emailEnabled!: boolean;

    public get notificationType(): NotificationType {
        return this._notificationType;
    }

    @OmitField()
    public set notificationType(value: any) {
        this._setValue('_notificationType', value, 'NotificationType');
    }

    public get pushEnabled(): boolean {
        return this._pushEnabled;
    }

    public set pushEnabled(value: any) {
        this._setValue('_pushEnabled', value, 'boolean');
    }

    public get emailEnabled(): boolean {
        return this._emailEnabled;
    }

    public set emailEnabled(value: any) {
        this._setValue('_emailEnabled', value, 'boolean');
    }

}
